export const BASE_HOST = 'https://www.houstonfirst.com'

export const THEME = {}
